import { fromJS } from 'immutable';
import * as types from './constants';

const initState = fromJS({
  lang: localStorage.getItem('language') || 'en',
  campaignsMobile: {},
});

export default (state = initState, action) => {
  const { type, payload } = action;
  switch (type) {
    case types.CHANGE_LANGUAGE: {
      return state.set('lang', payload);
    }
    case types.CAMPAIGNS_MOBILE: {
      return state.set('campaignsMobile', fromJS(payload));
    }
    case types.CAMPAIGNS_MOBILE_INDEX: {
      const campaignsMobile = { ...state.get('campaignsMobile').toJS() };
      const index = campaignsMobile.items.findIndex(
        (el) => el.id === payload.id
      );
      if (index > -1) {
        campaignsMobile.items[index] = { ...payload };
        return state.set('campaignsMobile', fromJS(campaignsMobile));
      }
      return state;
    }
    default:
      return state;
  }
};
